import { Fragment, useState, lazy, Suspense } from "react";
import { Helmet } from "react-helmet";
import MenuRepuestos from "../ecommerceRepuestos/MenuRepuestos";
import TipoBusquedaRepuestos from "../ecommerceRepuestos/TipoBusquedaRespuestos";
const Footer = lazy(() => import('../footer/Footer'));
function EcommerceRepuestos() {
  const [cartItems, setCartItems] = useState([]);
  const [showModalCart, setShowModalCart] = useState(false);
  const newAddProduct = (product) => {
    const ProductExist = cartItems.find((item) => item.id === product.id);
    if (ProductExist) {
      setCartItems(cartItems.map((item) =>
        item.id === product.id ? { ...ProductExist, quantity: ProductExist.quantity + 1 } : item
      ));
    } else {
      setCartItems([...cartItems, { ...product, quantity: 1 }]);
    }
  };

  const minProduct = (product) => {
    const ProductExist = cartItems.find((item) => item.id === product.id);
    if (ProductExist.quantity === 1) {
      setCartItems(cartItems.filter((item) => item.id !== product.id));
    } else {
      setCartItems(cartItems.map((item) =>
        item.id === product.id ? { ...ProductExist, quantity: ProductExist.quantity - 1 } : item
      ));
    }
  };

  return (
    <Fragment>
      <Helmet>
        <meta
          name="description"
          content="Ponte al día con Hyundai. Revisa las noticias relevantes de nuestra marca, no te pierdas de ninguna"
        />
        <meta name="keywords" content="Hyundai, noticias, actualidad" />
        <title>Compra Repuestos</title>
      </Helmet>
      <MenuRepuestos
        cartItems={cartItems}
        setShowModalCart={setShowModalCart}
        showModalCart={showModalCart}
        newAddProduct={newAddProduct}
        minProduct={minProduct}
      />
      <TipoBusquedaRepuestos
        newAddProduct={newAddProduct}
        minProduct={minProduct}
      />
      <Suspense fallback={<div>Cargando footer...</div>}>
        <Footer />
      </Suspense>
    </Fragment>
  );
}
export default EcommerceRepuestos;